import { Divider, Drawer, List, ListItem, ListItemButton, ListItemIcon, ListItemText } from '@mui/material';
import { useOktaAuth } from '@okta/okta-react';
import React from 'react';
import { Link, useLocation } from 'react-router-dom';

import LogoutIcon from '@mui/icons-material/Logout';
import PersonPinCircleIcon from '@mui/icons-material/PersonPinCircle';
import AddLocationAltIcon from '@mui/icons-material/AddLocationAlt';
import UserIcon from '@mui/icons-material/PermIdentity';


function LeftDrawer(props) {

    const { oktaAuth, authState } = useOktaAuth();

    const location = useLocation();

    if (!authState || !authState.isAuthenticated) return null;

    return <Drawer
        sx={{
            width: props.drawerWidth,
            flexShrink: 0,
            '& .MuiDrawer-paper': {
                width: props.drawerWidth,
                boxSizing: 'border-box',
            },
        }}
        variant="permanent"
        anchor="left">

        <List>
            <ListItem>
                <ListItemIcon><UserIcon /></ListItemIcon>
                <ListItemText primary={authState.idToken?.claims?.name} />
            </ListItem>
        </List>


        <Divider />

        <List component="nav">
            <ListItemButton component={Link} to="/" selected={location.pathname === '/'}>
                <ListItemIcon><AddLocationAltIcon /></ListItemIcon>
                <ListItemText primary="Secteur des agences" />
            </ListItemButton>
            <ListItemButton component={Link} to="/cd" selected={location.pathname === '/cd'}>
                <ListItemIcon><PersonPinCircleIcon /></ListItemIcon>
                <ListItemText primary="Chargés de dev" />
            </ListItemButton>
            <Divider />
            <ListItemButton onClick={() => oktaAuth.signOut()}>
                <ListItemIcon><LogoutIcon /></ListItemIcon>
                <ListItemText primary="Déconnexion" />
            </ListItemButton>
        </List>

    </Drawer>;
}

export default LeftDrawer;